import { createContext } from 'react';
import { IFormHook } from '../models';

export interface ILegoFormContext {
  formHook: IFormHook;
}

export const LegoFormContext = createContext<ILegoFormContext>({
  formHook: {} as IFormHook,
});
